/**
 * Auth slice
 * @format
 */

import { createAction } from "@reduxjs/toolkit";

// Actions
export const login = createAction("AUTH/LOGIN");
